export default "__VITE_ASSET__DmB29w7x__"